<template>
  <el-popover
    popper-class="form_pop el-select-dropdown spe_label" style="padding: 0;height: 330px;"
    @show="isIconDown = false" @hide="isIconDown = true"
  >
    <div class="spe" slot="reference">
      <label>特色标签</label>
      <div class="el-select__tags">
        <span>
          <span v-if="speTags.length === 0" style="color: #ccc;font-size: 12px;">请选择</span>
          <span
            class="el-tag el-tag--info el-tag--mini"
            v-for="eachTag in speTags" :key="eachTag.code"
          >
            <span class="el-select__tags-text">
              {{eachTag.codeName}}({{eachTag.choose.map(el => el.context).join(',')}})
            </span>
            <i class="el-tag__close el-icon-close" @click.stop="delSpeItem(eachTag)"></i>
          </span>
        </span>
      </div>
      <i class="el-icon-arrow-down spe_icon" :class="{ 'up': !isIconDown }"></i>
    </div>
    <div class="spe_list">
      <div class="fl left">
        <div v-for="(item, i) in speList" :key="i" @click="speTabChange(item, i)" :class="{ 'cur': curSpeTabI == i }">{{item.typeName}}</div>
      </div>
      <div class="fl right">
        <div v-for="(spe, z) in groupList" :key="z">
          <div class="spe-name" v-if="!curGroup.noShowGpName">{{spe.codeName}}</div>
          <SpeGroup :list="spe.list" v-model="dist[spe.code]" :isMuilt="spe.selectType == '2'" @distChange="distChange" :limit="spe.limit"></SpeGroup>
        </div>
      </div>
    </div>
  </el-popover>
</template>

<script>
import mulIcon from '@/assets/multiple_select.png'
import SpeGroup from './SpeGroup'
export default {
  name: 'Special',
  components: { SpeGroup },
  props: {
    config: {
      type: Object,
      default () { return {} }
    },
    value: Array
  },
  data () {
    return {
      mulIcon,
      speTags: [],
      allList: [],
      result: [],

      dist: {},
      curSpeTabI: 0,
      speList: [],
      curGroup: {
        noShowGpName: false,
        list: []
      },

      isIconDown: true
    }
  },
  computed: {
    labelListMap () {
      return this.$store.state.bmap.labelListMap
    },
    groupList () {
      return this.curGroup.list || []
    }
  },
  watch: {
    labelListMap: {
      immediate: true,
      handler () {
        this.initListData()
      }
    },
    speTags (v) {
      this.handleSpeCthHeight()
    }
  },
  methods: {
    handleLabelOriginList (list) { // 原始数据变成组件需要的数据
      list.forEach(el => {
        el.list = el.labelResponses || []
        el.list.forEach(ele => {
          ele.limit = el.limit
          ele.list = (ele.lableDetailsResponses || []).map(elem => {
            return { ...elem, label: elem.context, labelValue: elem.code + elem.value, codeName: ele.codeName, typeName: el.typeName }
          })
        })
        return el
      })
    },
    initListData () {
      // let labelListMap = this.$store.state.bmap.labelListMap
      // let allSpe = labelListMap ? Object.values(labelListMap).filter(el => el.group == '9') : []
      let searchPointLabelList = this.$store.state.bmap.searchPointLabelList
      let allSpe = searchPointLabelList.filter(el => el.group == '9')
      this.handleLabelOriginList(allSpe)
      // .map(el => {
      //   el.list = el.labelResponses
      //   el.list.forEach(ele => {
      //     ele.limit = el.limit
      //     ele.list = (ele.lableDetailsResponses || []).map(elem => {
      //       return { ...elem, label: elem.context, labelValue: elem.code + elem.value, codeName: ele.codeName, typeName: el.typeName }
      //     })
      //   })
      //   return el
      // })
      if (allSpe.length) {
        this.speList = allSpe.map(data => {
          if (data.typeName == '职业') data.noShowGpName = true // 不需要展示组名
          return data
        })
        this.speTabChange(this.speList[0], 0)
      }
      return

      // 初始化 dist
      // allSpe.forEach(el => { this.dist[el.code] = [] })
      // if (allSpe.length) {
      //   // 初始化 speList
      //   let typeGroup = this.arrSortByKey(allSpe, 'type', 'typeName')
      //   this.speList = typeGroup.map(el => {
      //     let data = { ...el, typeName: el.name, list: el.list }
      //     if (data.name == '职业') data.noShowGpName = true // 不需要展示组名
      //     return data
      //   })
      //   this.curGroup = this.speList[0]
      // }
    },
    speTabChange (item, i) {
      this.curSpeTabI = i
      this.curGroup = item
    },
    distChange () {
      let data = []
      let allContext = []
      let values = Object.values(this.dist)
      Object.values(this.dist).forEach(arr => {
        arr.forEach(el => {
          allContext.push(el)
          data.push(el.labelValue)
        })
      })
      this.$emit('input', data)
      this.speTags = this.arrSortByKey(allContext, 'code', 'codeName').map(el => ({ ...el, codeName: el.name, choose: el.list }))
    },
    arrSortByKey (arr, keyStr, keyNameStr) { // 一维数组转换成整理成二维数组，根据 keyStr 相同的整理组合
      let data = []
      let types = [ ...new Set(arr.map(el => el[keyStr])) ]
      types.forEach(el => {
        let curTypeList = arr.filter(ele => ele[keyStr] == el)
        data.push({
          type: el, list: curTypeList, name: curTypeList[0][keyNameStr]
        })
      })
      return data
    },
    delSpeItem (item) {
      this.dist[item.type] = []
      this.distChange()
    },
    handleSpeCthHeight () {
      this.$nextTick(() => {
        document.querySelector('.spe').style.height = document.querySelector('.spe .el-select__tags').clientHeight + 10 + 'px'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.spe_list {
  height: 100%;
  padding: 1px;
  > .fl {
    height: 100%;
    &.left {
      background: #F5F5F5;
      width: 68px;
      line-height: 40px;
      text-align: center;
      padding-top: 10px;
      div {
        cursor: pointer;
        &.cur {
          color: #FF3973;
          background: #fff;
        }
      }
    }
    &.right {
      width: calc(100% - 68px);
      overflow: auto;
      padding-top: 20px;
      background: #fff;
    }
  }
  .spe-name {
    font-size: 12px;
    color: #666;
    margin: 0 5px;
  }
  // span {
  //   display: inline-block;
  //   position: relative;
  //   width: 63px;
  //   line-height: 30px;
  //   border: 1px solid #E9E9E9;
  //   margin: 5px;
  //   font-size: 12px;
  //   cursor: pointer;
  //   text-align: center;
  //   img {
  //     display: none;
  //     position: absolute;
  //     top: 0;
  //     right: 0;
  //   }
  //   &.select {
  //     border-color: #282729;
  //     img {
  //       display: block;
  //     }
  //   }
  // }
}
.spe {
  border: 1px solid #e9e9e9;
  min-height: 38px;
  position: relative;
  border-radius: 4px;
  .spe_icon {
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -5px;
    color: #c0c4cc;
    &.up {
      transform: rotate(180deg);
      transition: all 0.2s
    }
  }
  > label {
    font-weight: 600;
    position: absolute;
    left: 20px;
    top: 50%;
    margin-top: -10px;
    z-index: 1;
    padding-right: 10px;
    border-right: 1px solid #e9e9e9;
  }
  .el-select__tags {
    padding-left: 100px;
    width: 290px;
    .el-tag--info.el-tag--mini {
      background-color: #f0f2f5;
      border-color: transparent;
      margin: 2px 2px 2px 0;
    }
    .el-tag__close.el-icon-close {
      background-color: #c0c4cc;
      top: -7px;
      color: #fff;
    }
    .el-select__tags-text {
      display: inline-block;
      max-width: 170px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
